import { Outlet } from 'react-router-dom'

import { ResponsivePage } from 'modules/layout/components/ResponsivePage'
import CollectionsBootstrap from 'modules/performance_feedbacks/lib/CollectionsBootstrap'

const RootPage = () => {
  return (
    <CollectionsBootstrap>
      <ResponsivePage.Body>
        <Outlet />
      </ResponsivePage.Body>
    </CollectionsBootstrap>
  )
}

export default RootPage
